import React from 'react';
import { Form, Input, Select, DatePicker, notification } from 'antd';
import { observer } from 'mobx-react';

import { formatDate } from '../../../utils/functions';
import AddEditStore from './Store';
import moment from 'moment';
import { checkDuplicateEmail, checkDuplicateLastName } from './service';
import { convertPhoneFaxNumber } from '@utils/functions';

const title = [
  {
    value: 'Dr.',
    title: 'Dr.',
  },
  {
    value: 'Master',
    title: 'Master',
  },
  {
    value: 'Miss',
    title: 'Miss',
  },
  {
    value: 'Mr.',
    title: 'Mr.',
  },
  {
    value: 'Mrs.',
    title: 'Mrs.',
  },
  {
    value: 'Ms.',
    title: 'Ms.',
  },
];

@observer
class GeneralInformation extends React.Component {
  convertDate = dateString => {
    if (dateString) {
      if (typeof dateString === 'string') {
        if (dateString.search('/Date') !== -1) {
          const dateFormat = formatDate(dateString);
          return moment(dateFormat, 'DD MMM,YYYY');
        }
      } else {
        return moment(dateString, 'DD/MM/YYYY');
      }
    }
    return null;
  };
  openModalDuplicate = (arrayDuplicate, type) => {
    return AddEditStore.toggleModal(true, {
      modalType: 'checkDuplicate',
      dataDuplicate: arrayDuplicate || [],
      type,
    })();
  };
  handleCheckDuplicate = (id, value, fieldName) => {
    AddEditStore.setFieldsValue({ loadingCheckDuplicate: true });
    if (fieldName === 'Email') {
      Promise.all([checkDuplicateEmail(id, value)])
        .then(([duplicateValue]) => {
          this.openModalDuplicate(duplicateValue.lstObjs, 'Email');
          AddEditStore.setFieldsValue({ loadingCheckDuplicate: false });
        })
        .catch(() => {
          notification.destroy();
          notification.error({
            message: 'Error',
            description: 'An error occurred on the server',
            duration: 2,
          });
          AddEditStore.setFieldsValue({ loadingCheckDuplicate: false });
        });
    }
    if (fieldName === 'LastName') {
      Promise.all([checkDuplicateLastName(id, value)])
        .then(([duplicateValue]) => {
          this.openModalDuplicate(duplicateValue.lstObjs, 'LastName');
          AddEditStore.setFieldsValue({ loadingCheckDuplicate: false });
        })
        .catch(() => {
          notification.destroy();
          notification.error({
            message: 'Error',
            description: 'An error occurred on the server',
            duration: 2,
          });
          AddEditStore.setFieldsValue({ loadingCheckDuplicate: false });
        });
    }
  };
  render() {
    const { claimantInfo } = AddEditStore;
    return (
      <Form name="general-information">
        <Form.Item label="Claimant ID" required>
          <Input
            size="large"
            value={claimantInfo.Id === 0 ? '' : claimantInfo.Id}
            disabled={true}
          />
        </Form.Item>
        <Form.Item label="Title">
          <Select
            size="large"
            value={claimantInfo.Title}
            onChange={AddEditStore.handleFieldChange('Title')}
          >
            {title.map((i, index) => (
              <Select.Option key={index} value={i.value}>
                {i.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="First Name"
          required
          validateStatus={AddEditStore.errors['FirstName'] ? 'error' : null}
          help={AddEditStore.errors['FirstName']}
        >
          <Input
            size="large"
            value={claimantInfo.FirstName}
            onChange={AddEditStore.handleFieldChange('FirstName')}
          />
        </Form.Item>
        <Form.Item
          required
          validateStatus={AddEditStore.errors['LastName'] ? 'error' : null}
          help={AddEditStore.errors['LastName']}
          label={
            <React.Fragment>
              Last Name
              <button
                className="check-duplicate"
                onClick={() =>
                  this.handleCheckDuplicate(
                    claimantInfo.Id,
                    claimantInfo.LastName,
                    'LastName',
                  )
                }
              >
                Check duplicate
              </button>
            </React.Fragment>
          }
        >
          <Input
            size="large"
            value={claimantInfo.LastName}
            onChange={AddEditStore.handleFieldChange('LastName')}
          />
        </Form.Item>
        <Form.Item
          label="Phone"
          validateStatus={AddEditStore.errors['HomePhone'] ? 'error' : null}
          help={AddEditStore.errors['HomePhone']}
        >
          <Input
            size="large"
            value={convertPhoneFaxNumber(claimantInfo.HomePhone)}
            onChange={AddEditStore.handleFieldChange('HomePhone')}
          />
        </Form.Item>
        <Form.Item
          label="Mobile"
          validateStatus={AddEditStore.errors['Telephone'] ? 'error' : null}
          help={AddEditStore.errors['Telephone']}
        >
          <Input
            size="large"
            value={claimantInfo.Telephone}
            onChange={AddEditStore.handleFieldChange('Telephone')}
          />
        </Form.Item>
        <Form.Item
          validateStatus={AddEditStore.errors['Email'] ? 'error' : null}
          help={AddEditStore.errors['Email']}
          label={
            <React.Fragment>
              Email
              <button
                className="check-duplicate"
                onClick={() =>
                  this.handleCheckDuplicate(
                    claimantInfo.Id,
                    claimantInfo.Email,
                    'Email',
                  )
                }
              >
                Check duplicate
              </button>
            </React.Fragment>
          }
        >
          <Input
            size="large"
            value={claimantInfo.Email}
            onChange={AddEditStore.handleFieldChange('Email')}
          />
        </Form.Item>
        <Form.Item label="Date of Birth">
          <DatePicker
            size="large"
            value={this.convertDate(claimantInfo.DOB)}
            onChange={AddEditStore.handleFieldChange('DOB')}
            format="DD/MM/YYYY"
          />
        </Form.Item>
        <Form.Item label="Address">
          <Input
            size="large"
            value={claimantInfo.Address}
            onChange={AddEditStore.handleFieldChange('Address')}
          />
        </Form.Item>
        {/* <Form.Item label="Suburb">
          <Input size="large" />
        </Form.Item>
        <Form.Item label="State">
          <Select size="large" value="1">
            <Select.Option value="1">ACT</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Country" style={{ marginBottom: 0 }}>
          <Select size="large" value="1">
            <Select.Option value="1">Australia</Select.Option>
          </Select>
        </Form.Item> */}
      </Form>
    );
  }
}

export default GeneralInformation;
